export const getImageSource = `${process.env.REACT_APP_REWRITE_IMAGE_HOSTNAME}` === 'undefined'
  ? function(src) {return src;}
  : function(src) {
    if (!src) return '';
    try {
      const u = new URL(src);
      const idx = u.pathname.indexOf('/uploads/');
      const pathname = u.pathname.substr(idx);
      return `${u.protocol}//${process.env.REACT_APP_REWRITE_IMAGE_HOSTNAME}${process.env.PUBLIC_URL}${pathname}`;
    } catch (err) {
      console.log(`Can't parse image source: ${src}`, err);
      return '';
    }
  };



// WEBPACK FOOTER //
// ./src/utils/images.js